<template>
<div style="background-color: #43a047;">
  <div class="container">
    <div class="b_contain" id="containLoader">
      <div class="sign-up-conatiner">
        <div class="welcome">
          <router-link class="navbar-brand" :to="{ name: 'Home' }">
          <img
            class="welcome-img"
            style=""
            alt="Secc logo"
            src="../../assets/secclogo.png"
          />
          </router-link>
          <h3 class="welcome-title">Welcome to Our Training</h3>
          <p class="welcome-proword">To Keep Connection to our Training</p>

          <p class="welcome-proword">We Support with: </p>
          <a class="navbar-brand" href='https://camdigikey.gov.kh/' target="_blank">
            <img src="@/assets/images/unnamed.webp"  width="80"/>
          </a>
          <p class="welcome-proword mt-2">
            Download CamDigiKey app: 
            <a href="https://play.google.com/store/apps/details?id=kh.gov.camdx.camdigikey" 
              target="_blank" 
              class="text-white"
              >ANDROID</a> or 
              <a href="https://apps.apple.com/kh/app/camdigikey/id1509386989" 
              class="text-white"
              target="_blank">
              iOS
              </a> .
          </p>
        </div>
        <div class="sign-up-form">
          <form v-on:submit.prevent style="width: 400px;">
            <div class="mb-3 icon-edu" style="">
              <i
                class="fa fa-graduation-cap"
                aria-hidden="true"
                style="font-size: 58px;"
              ></i>
            </div>
            <div class="mb-3">
              <label for="exampleInputEmail1" class="form-label"
                >Email</label
              >
              <input
                type="text"
                class="form-control"
                v-model.trim="loginform.email"
                :class="{ 'is-invalid': v$.loginform.email.$error }"
              />
            </div>
            <div class="">
              <label for="exampleInputPassword1" class="form-label"
                >Password</label
              >
              <input
                type="password"
                class="form-control"
                v-model.trim="loginform.password"
                :class="{ 'is-invalid': v$.loginform.password.$error }"
              />
            </div>
            <p style="text-align:right; font-size:12px;">
              <router-link style="color:#fff;" :to="{ name: 'ForgetPassword' }"
                >Forget Password?</router-link> 
            </p>
            
            <div style="text-align:center;">
              <button
                type="buttom"
                class="btn btn-warning"
                style="width:100%"
                @click="singin"
              >
                Sign In <i class="fas fa-sign-in-alt"></i>
              </button>
              <!-- <router-link class="btn btn-warning" :to="{ name: 'SingUp' }">
              Sing Up
            </router-link> -->
            </div>
            
            <!-- <div class="m-3 form-check text-center">
              Or
              <router-link style="color:#fff;" :to="{ name: 'SingUp' }"
                >Sign Up</router-link
              >
            </div> -->
            <div class="p-0 mt-3 form-check text-center">
              Or
              <button
                type="buttom"
                class="btn btn-primary mt-3"
                style="width:100%"
                @click.prevent="getCamDigikey"
              >
                <img src="@/assets/images/unnamed.webp" width="25" class="mr-2"/> Sign In with CamDigiKey
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "@/axios";

export default {
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      loginform: {
        email: "",
        password: ""
      }
    };
  },
  validations() {
    return {
      loginform: {
        email: { required, $autoDirty: true },
        password: { required, $autoDirty: true }
      }
    };
  },
  methods: {
    showLoader() {
      return this.$loading.show({
        // Optional parameters
        container: this.$refs.containLoader,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    async singin() {
      let loader = this.showLoader();
      try {
        const response = await this.$store.dispatch("act_login", {
          data: this.loginform,
          toast: this.$toast
        });

        
        if (response.success) {
          loader.hide();
          if(this.$store.getters.getAuthRole[0]=='user'){
            this.$router.push({ name: "Home" });
          }else if(this.$store.getters.getAuthRole[0]=='supperAdmin'){
            this.$router.push({ name: "adminNewRegistor" });
          }else if(this.$store.getters.getAuthRole[0]=='Admin'){
            this.$router.push({ name: "adminNewRegistor" });
          }else if(this.$store.getters.getAuthRole[0]=='Account'){
            this.$router.push({ name: "invoiceManagement" });
          }
          
        } else {
          loader.hide();
          this.$toast.open({
            message: "Login fail " + response.message,
            type: "error",
            duration: 5000,
            dismissible: true,
            position: "top-right"
          });
        }
        //console.log("it is respone:", response);
      } catch (error) {
        loader.hide();
        //console.log("it is error:", error);
      }
    },
    async getCamDigikey() {
      let loader = this.showLoader();
      try {
          let response = await axios.post("get-camdigikey");
          if (response.data.status) {
            loader.hide();
            window.location.href = response.data.response.loginUrl;
          } else {
            loader.hide();
            this.$toast.open({
              message: "Login fail " + response.message,
              type: "error",
              duration: 5000,
              dismissible: true,
              position: "top-right"
            });
          }
        //console.log("it is respone:", response);
      } catch (error) {
        loader.hide();
        //console.log("it is error:", error);
      }
    }
  }
};
</script>

<style scoped>
.b_contain {
  display: flex;
  height: 100vh !important;
  width: 100%;
  align-items: center;
  justify-content: center;
  font-family: 14px;
}
.sign-up-conatiner {
  width: 100%;
  display: flex;
  background-color: #43a047;
  border-radius: 12px;
  box-shadow: blue;
  color: #fff;
  margin-top: 20px;
  height: 90%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.welcome {
  background-color: #2e7d32;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 50px 20px;
  align-items: center;
  justify-content: center;
}
.sign-up-form {
  /* background-color: coral; */
  display: flex;
  flex: 2;
  padding: 20px;
  justify-content: center;
  align-items: center;
}
.width-bottom {
  width: 80%;
}
.welcome-img {
  width: 132px;
  margin-bottom: 22px;
}
.welcome-title {
  padding: 5px;
  font-size: 22px;
  text-align: center;
}
.welcome-proword {
  padding: 5px;
  text-align: center;
}
.icon-edu {
  margin-bottom: 25px !important;
  text-align: center;
}
@media (max-width: 774px) {
  .b_contain {
    height: auto;
  }
  .welcome {
    padding: 0;
  }
  .welcome-title {
    padding: 2px;
    font-size: 16px;
    margin-bottom: 0;
  }
  .welcome-proword {
    padding: 0px;
  }
  .sign-up-conatiner {
    flex-direction: column;
    width: 100%;
  }
  .welcome-img {
    width: 90px;
    margin-bottom: 0;
  }
  .icon-edu {
    display: none;
  }
  .frmSignin{
    width: 400px;
  }
}
</style>
